import { colors } from "@styles/index";
import { type CellClickedEvent, type ColDef } from "ag-grid-community";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import styled from "styled-components";
import DataEmpty from "../DateEmpty";

type TableProps<T> = {
    currentPageSize?: number;
    rowData: T[];
    tableContentsInfoData: ColDef[];
    minHeight?: number;
    onDetailClick?: (uuid: string) => void;
    onTermsDetailClick?: (category: string) => void;
    onRowClick?: (data: T) => void;
};

const Table = <T extends object>({ currentPageSize, minHeight = 331, rowData, tableContentsInfoData, onDetailClick, onTermsDetailClick, onRowClick }: TableProps<T>) => {
    const gridRef = useRef<AgGridReact<T>>(null);
    const PAGE_SIZE = 10;
    const ROW_HEIGHT = 48;

    const tableHeight = () => {
        if (!currentPageSize) {
            return;
        }

        const ROW_HEIGHT = 48;
        const HEADER_HEIGHT = 50;
        const dataLength = rowData.length;
        const height = dataLength * ROW_HEIGHT + HEADER_HEIGHT;
        return `${height}px`;
    };

    return (
        <TableWrap
            className="ag-theme-alpine"
            style={{
                width: "100%",
                height: `${tableHeight()}`,
                margin: "0 auto",
                minHeight: `${minHeight}px`,
            }}
        >
            <AgGridReact
                ref={gridRef}
                rowData={rowData}
                rowHeight={ROW_HEIGHT}
                suppressCellFocus
                suppressDragLeaveHidesColumns
                paginationAutoPageSize={true}
                paginationPageSize={currentPageSize || PAGE_SIZE}
                noRowsOverlayComponent={DataEmpty}
                overlayLoadingTemplate={"로딩중입니다..."}
                defaultColDef={{
                    resizable: false,
                    suppressMenu: false,
                    flex: 1,
                    sortable: false,
                    cellStyle: {
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 400,
                        color: colors.GRAY2,
                        lineHeight: "20px",
                    },
                }}
            >
                {tableContentsInfoData.map(({ field, pinned, minWidth, headerName, ...res }, idx) => {
                    return (
                        <AgGridColumn
                            lockPinned={true}
                            key={idx + 10}
                            field={field}
                            pinned={pinned || false}
                            minWidth={minWidth}
                            headerName={headerName}
                            onCellClicked={(e: CellClickedEvent<T>) => {
                                const data = e.data;
                                if (!data) {return;}

                                if (onDetailClick && 'uuid' in data && typeof data.uuid === 'string') {
                                    onDetailClick(data.uuid);
                                }
                                if (onTermsDetailClick && 'category' in data && typeof data.category === 'string') {
                                    onTermsDetailClick(data.category);
                                }
                                if (onRowClick) {
                                    onRowClick(data);
                                }
                            }}
                            {...res}
                        />
                    );
                })}
            </AgGridReact>
        </TableWrap>
    );
};

export default Table;

export const TableWrap = styled.div`
    /* pass */
    width: 100%;
    height: 100%;

    .exposure {
        position: relative;
        color: ${colors.PRIMARY};

        ::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            background: ${colors.PRIMARY};
            position: absolute;
            left: 0;
            border-radius: 50%;
        }
    }

    .unExposure {
        position: relative;
        color: ${colors.GRAY6};

        ::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            background: ${colors.GRAY6};
            position: absolute;
            left: 0;
            border-radius: 50%;
        }
    }
`;
